import { render } from "./ChangeDetails.vue?vue&type=template&id=38319df6"
import script from "./ChangeDetails.vue?vue&type=script&lang=js"
export * from "./ChangeDetails.vue?vue&type=script&lang=js"

import "./ChangeDetails.vue?vue&type=style&index=0&id=38319df6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__